export default "__VITE_ASSET__CACC9Vvy__"